import FormControl from 'components/common/form-control/FormControl';
import Input from 'components/common/input/Input';
import { TextType } from 'components/common/title/Title';
import { ChangeEvent } from 'react';
import { Point } from 'types/feature/workspace/workspace';

type Props = {
  point: Point;
  handlePoint: (point: Point) => void;
};

const TimeForm = ({ point, handlePoint }: Props) => {
  const handleChangeTime = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;

    handlePoint({
      ...point,
      operation: {
        ...point.operation,
        [name]: value,
      },
    });
  };

  return (
    <div className='flex flex-col gap-4'>
      {/* 시작 */}
      <FormControl
        name='시작'
        labelSize='none'
        labelStyle={TextType.body1}
        labelColor='text-gray-99'
        control={
          <Input
            type='time'
            size={128}
            name='hoursStart'
            onChange={handleChangeTime}
            value={point.operation.hoursStart}
          />
        }
      />

      {/* 종료 */}
      <FormControl
        name='종료'
        labelSize='none'
        labelStyle={TextType.body1}
        labelColor='text-gray-99'
        control={
          <Input type='time' size={128} name='hoursEnd' onChange={handleChangeTime} value={point.operation.hoursEnd} />
        }
      />
    </div>
  );
};

export default TimeForm;
